import { Grid, Typography, Box, SxProps, Theme } from "@mui/material";

type TotalPercentageDisplayProps = {
  totalPercentage: number;
  allowUnder100?: boolean;
  sx?: SxProps<Theme>;
};

const is100 = (num: number) => num !== 100;
const isOver100 = (num: number) => num > 100;

export const TotalPercentageDisplay = ({
  totalPercentage,
  allowUnder100 = false,
  sx = {},
}: TotalPercentageDisplayProps) => {
  const isErrorColor = allowUnder100 ? isOver100 : is100;
  return (
    <Grid container justifyContent={"space-between"} sx={sx} spacing={2}>
      <Grid size={2}>
        <Typography variant="h6">Total</Typography>
      </Grid>
      <Grid size={8}>
        <Box
          sx={{
            width: "calc(100% - 16px)",
            position: "relative",
            left: 2,
            borderTop: "3px dotted black",
            marginTop: 2,
            marginLeft: 2,
            marginRight: 2,
          }}
        />
      </Grid>
      <Grid size={2} sx={{ textAlign: "right" }}>
        <Typography
          variant="h6"
          color={isErrorColor(totalPercentage) ? "error" : ""}
        >
          {Math.round(totalPercentage)}%
        </Typography>
      </Grid>
    </Grid>
  );
};
